import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-32 relative overflow-hidden flex items-center justify-center" data-id="element-78">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#2A2A2B] via-[#121212] to-[#121212] opacity-50" data-id="element-79"></div>

      <motion.div className="relative z-10 text-center px-6" initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-80">
        <h2 className="font-serif text-4xl md:text-6xl mb-12 tracking-wide" data-id="element-81">
          YOUR TRANSFORMATION <br data-id="element-82" />
          <span className="text-gold italic" data-id="element-83">STARTS HERE</span>
        </h2>
        <Button data-id="element-84">Book Now</Button>
      </motion.div>
    </section>;
}